<template>
  <help-info-wrapper
    :info.sync="helpData"
    :service-name="serviceName"
    class="warp"
  >
    <template>
      <v-overlay :value="isAutoSaving" z-index="9999" opacity="0.8" v-if="AutoSave">
          <div class="text-center d-flex flex-column align-center justify-center">
            <atom-spinner :animation-duration="1500" :size="100" class="mx-auto" color="#038118"/>
            <h3 class="mt-4 green--text">در حال ذخیره سازی خودکار...</h3>
            <p class="green--text mt-2">لطفاً چند لحظه صبر کنید</p>
          </div>
      </v-overlay>

      <v-row class="pa-2" no-gutters>
        <v-col class="pa-2 mb-4 sticky-md" cols="12" md="4" style="top: 12px">
          <v-tabs
            v-model="qrShow"
            background-color="grey lighten-3 pa-1"
            class="rounded-pill mx-auto pa-1"
            color="primary"
            height="48"
            style="width: fit-content"
          >
            <v-tab :disabled="e6 <= 1" :ripple="true"> مشاهده QR </v-tab>

            <v-tab :ripple="true"> پیش نمایش </v-tab>
            <v-tab :ripple="true" :disabled="e6 <= 1">تعرفه‌ها</v-tab>

          </v-tabs>
        </v-col>

        <v-col v-show="$vuetify.breakpoint.mdAndUp" cols="8" />

        <v-col
          class="pa-2 sticky-md"
          cols="12"
          md="4"
          style="top: 100px; height: fit-content"
        >
          <v-tabs-items
            v-model="qrShow"
            class="overflow-visible mb-4 mb-md-0"
            touchless
          >
            <v-tab-item>
              <qr-maker :loading="loading" />

              <v-btn class="btn-download" @click="showDialog = true">
                <v-icon>mdi-progress-download</v-icon>
                {{ $t("download_qr") }}              </v-btn>
            </v-tab-item>

            <v-tab-item>
              <consultation-qr-view v-model="cardTexts" :qr-svg-data-url="qrSvgDataUrl"/>
            </v-tab-item>
          <v-tab-item v-if="!!info?.id && e6>1">
              <Tariffs :id_qr="info.id" :qrtype="'consultationQr'" />
          </v-tab-item>

          </v-tabs-items>
        </v-col>

        <v-col cols="12" md="8">
          <v-stepper v-model="e6" class="px-0 mx-0 qr-stepper" flat vertical>
            <v-stepper-step :complete="e6 > 1" class="px-0 px-md-4" step="1">
              <div class="row justify-center">
                <div class="col-md-12">
                  <p>وارد کردن اطلاعات فرم درخواست</p>
                </div>
                <div class="col-md-6 mt-0 pt-0 rowinfo">
                  <v-text-field
                    v-model="cardTexts.visitName"
                    :disabled="e6 > 1"
                    append-icon="mdi-pen"
                    class="mt-0 pt-0 contentinfo"
                    clear-icon="mdi-close-circle-outline"
                    clearable
                    dense
                    label="نام فرم درخواست شما"
                    outlined
                  />
                  <help-info
                    :element-name="`${serviceName}-${componentName}-visitName`"
                    :service-name="serviceName"
                    :help-data="helpData"
                    class="buttoninfo"
                    label="نام گالری"
                  />
                </div>
                <div class="col-md-6 mt-0 pt-0 rowinfo">
                  <qr-address-field
                    id="qr-address"
                    ref="address-field"
                    v-model="dtUrl"
                    :disabled="e6 > 1"
                    :error-messages="errors['identifier']"
                    append-icon="mdi-web"
                    class="mt-0 pt-0 contentinfo"
                    dense
                    outlined
                    persistent-hint
                    @updateDest="domainId = $event"
                    :key="$t('qrAddressUpdate.hints.allowedChars')"
                    :hint="$t('qrAddressUpdate.hints.allowedChars')"

                  />
                  <help-info
                    :element-name="`${serviceName}-${componentName}-dtUrl`"
                    label="آدرس کیوآر"
                    :service-name="serviceName"
                    :help-data="helpData"
                    class="buttoninfo"
                  />
                </div>
              </div>
            </v-stepper-step>
            <v-stepper-content class="pr-1 mx-0 mr-md-7 px-md-4" step="1">
              <div class="col-md-12">
                <next-btn
                  :loading="loading"
                  style="background: #1b8d39"
                  @click="markQr"
                />
              </div>
            </v-stepper-content>
            <v-stepper-step :complete="e6 > 2" class="px-0 px-md-4" step="2">
              اطلاعات
            </v-stepper-step>
            <v-stepper-content class="pr-1 mx-0 mr-md-7 px-md-4" step="2">
              <div class="mb-4">
                <!-- سوییچ و آیکون راهنما -->
                <div class="d-flex align-center">
                  <v-switch
                    v-model="AutoSave"
                    color="primary"
                    class="mt-0 pt-0 shrink"
                    hide-details
                    label="ذخیره خودکار"
                  ></v-switch>

                  <!-- آیکون راهنما با Tooltip (هاور برای دسکتاپ و تاچ برای موبایل) -->
                  <v-tooltip bottom max-width="320">
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        icon
                        x-small
                        class="mr-1"
                        v-bind="attrs"
                        v-on="on"
                        @click.stop
                      >
                        <v-icon small color="grey darken-1">
                          mdi-help-circle-outline
                        </v-icon>
                      </v-btn>
                    </template>
                    <span>
                      تغییرات هر بخش با بستن آن بخش به‌صورت خودکار ذخیره می‌شود. (تنظیمات کلی شامل ذخیره خودکار نیستند)
                    </span>
                  </v-tooltip>
                </div>

                <!-- متن کم‌رنگ و ظریف اختصاصی برای موبایل (زیر سوییچ) -->
                <div
                  v-if="$vuetify.breakpoint.xsOnly"
                  class="text-caption grey--text text--darken-1 mt-1 pr-1"
                  style="line-height: 1.4"
                >
                  تغییرات هر بخش با بستن آن بخش به‌صورت خودکار ذخیره می‌شود. (تنظیمات کلی شامل ذخیره خودکار نیستند)
                </div>
              </div>

              <list-expansion
                v-model="cardTexts"
                :components="specialInfo"
                :data="cardTexts"
                :service-name="serviceName"
                :component-name="componentName"
                @save-required="AutoSave && qrUpdate(false)"
                flat />
              <next-btn
                :loading="loading"
                style="background: #1b8d39"
                @click="qrUpdate(true)"
            /></v-stepper-content>
          </v-stepper>

          <div class="d-none">
            <qr-code-make
              ref="qrCanvas"
              v-model="qrDesign"
              :file.sync="qrSvgDataUrl"
              :link="fullLink"
              @save="qrDesign = $event"
            />
          </div>

          <custom-popup
            v-model="showDialog"
            :cons="cons"
            hide-confirm
            max-width="900"
            transition="dialog-bottom-transition"
          >
            <template v-slot:helpinfo>
              <help-info
                :element-name="`${serviceName}-${componentName}-data-show-download-d`"
                :service-name="serviceName"
                :help-data="helpData"
                class="buttoninfo"
                label="دانلود کیوآر"
              />
            </template>
            <v-card class="pa-5">
              <download-file-with-api
                v-if="showDialog"
                :address="`${info?.domain?.name||'qrland.in/'}${info?.identifier}`"
                :visit-name="cardTexts.visitName"
                :qr_id="info.qrId"

              />
            </v-card>
          </custom-popup>
        </v-col>
      </v-row>
    </template>
  </help-info-wrapper>
</template>

<script>
import { Bus } from "@/main";
import HelpInfo from "../../qrland/components/helpAcordion/HelpInfo.vue";
import HelpInfoWrapper from "../../qrland/components/helpAcordion/HelpInfoWrapper.vue";
import QrMaker from "@/view/pages/qrland/components/qrMaker.vue";
import VideoGalleryMobile from "@/view/pages/otherQrTypes/videoGallery/components/galleryMobile.vue";
import QrAddressField from "@/view/content/fragments/qrAddressField.vue";
import ListExpansion from "@/view/content/fragments/listExpansion.vue";
import NextBtn from "@/view/content/fragments/nextBtn.vue";
import QrManagement from "@/view/pages/qrland/components/qrManage/qrManagement.vue";
import PrevBtn from "@/view/content/fragments/prevBtn.vue";
import QrCodeMake from "@/view/pages/qrland/qrCodeStyle/qrCodeMake.vue";
import DownloadFileWithApi from "@/view/pages/qrland/downloadFileWithApi.vue";
import consultationQrView from "./components/consultationQrView.vue";
import { mapActions } from "vuex";
import { getLanguageCookie } from "../../../../core/plugins/TitleRibbon/utils/languageCookie";
import Tariffs from "../../../components/Tariffs/Tariffs.vue";
import { AtomSpinner } from "epic-spinners";

export default {
  name: "consultationQr",

  components: {
    HelpInfo,
    HelpInfoWrapper,
    DownloadFileWithApi,
    QrCodeMake,
    PrevBtn,
    QrManagement,
    NextBtn,
    ListExpansion,
    QrAddressField,
    VideoGalleryMobile,
    consultationQrView,
    QrMaker,
    Tariffs,AtomSpinner
  },

  data() {
    return {
      isAutoSaving: false, 
      AutoSave:false,
      helpData: [],
      serviceName: "Qrland",
      componentName: "consultationQr",
      e6: 1,
      qrShow: 1,
      domainId: null,
      createdDomain: null,
      createdId: null,
      dtUrl: null,
      showDialog: false,
      loading: false,
      finish: true,
      errors: {},
      qrDesign: {},
      cons: { title: "دانلود کیوآر" },
      info: null,
      cardTexts: {
        visitName: "فرم درخواست",
        consultationNew: {
          title: "فرم درخواست",
          description: "",
          sectionColor: { backGround: "", text: "" },
          conform: false,
        },

        baseInfo: {
          sectionColor: {
            backGround: "linear-gradient(to right , #350808, #270DF5)",
            text: "#fff",
          },
          slider: false,
          grid: false,
        },
        pallete: {
          headColor: "linear-gradient(to top, #A87676, #E1ACAC)",
          bodyColor: "linear-gradient(to top right , #A87676, #E1ACAC)",
          textColor: "#ffffff",
          borderColor: "#393939",
        },

        banner: {
          images: [
            {
              title: "WhatsApp Image 2022-06-08 at 4.01.18 PM(2)",
              url: "https://cdn.terminalads.com/upload/63fb1ed3aaa06.webp",
              description: "",
              link: "",
            },
            {
              title: "565089-dota-2-wallpaper",
              url: "https://cdn.terminalads.com/upload/645756ebac0ba.webp",
              description: "",
              link: "",
            },
            {
              title: "ali_larter_3-wallpaper-1600x900",
              url: "https://cdn.terminalads.com/upload/6457570fef1ea.webp",
              description: "",
              link: "",
            },
          ],
          name: "بنر",
        },
        photo: {
          profile: "",
          transition: "scale",
          hasWelcome: false,
          showWelcome: false,
          hasGif: false,
          hasGame: false,

          previewerQr: {
            previewer: {
              gif: "",
              game: {},
              transition: "scale",
            },
          },
        },
        organizationName: "کیو آر لند",
        aboutUs:
          "در بازخورد، با اسکن یک QR به‌سادگی فرم درخواست خود را به  کاربران   ارئه دهید.",
        subtitle: "روشی ساده برای ارائه فرم درخواست به  کاربران با اسکن یک QR",
        website: "",
        PicSelector: {
          title: "عنوان",
          description: "توضیحات",
          sectionColor: {
            backGround: "",
            text: "",
          },
          slider: false,
          grid: true,
        },
        extraFields: [
          {
            icon: "",
            name: "",
            value: "",
          },
        ],
        socialMedia: {},
      },
      specialInfo: [
        {
          name: "baseInfo",
          value: "",
          title: "اطلاعات",
          icon: "account-outline",
        },
        {
          name: "imageUploader",
          value: "",
          title: "آپلود لوگو",
          icon: "image",
          model: "photo",
        },
        {
          name: "consultationNew",
          value: "",
          title: "فرم درخواست",
          subtitle: "",
          icon: "list-box-outline",
          model: "consultationNew",
          settings: {
            notColor: true,
          },
        },
        {
          name: "socialMediaIcons",
          value: "",
          title: "افزودن شبکه های اجتماعی",
          subtitle: "",
          icon: "instagram",
          model: "socialMedia",
        },
        {
          name: "colorPallete",
          value: "",
          title: "انتخاب رنگ",
          subtitle: "",
          icon: "format-color-fill",
          model: "pallete",
        },
      ],
      qrSvgDataUrl: "",
    };
  },

  watch: {
    "$i18n.locale"(newLocale, oldLocale) {
      if (newLocale !== oldLocale) {
        localStorage.setItem("language", newLocale);
      }
    },
  },
  mounted() {
    const savedLanguage = getLanguageCookie() || "fa";
    this.$i18n.locale = savedLanguage;
    this.cardTexts.photo.profile =
      this.$coreApi3 + "/storage/s5wXoRhzyw9PkGXA8qnIL2yvA3TPiXhwsFrwjmeX.png";
    this.cardTexts.website = this.$coreqrApi;
    this.cardTexts.socialMedia = {
      address: [
        {
          label: "آدرس",
          text: "لینک سایت مورد نظر را وارد نمایید",
          pattern: "",
          prefix: "URL",
          url: "qrland.ir",
          img: "/media/socialIcon/40icon/location.svg",
          svg: "svgLocation",
        },
        {
          label: "آدرس",
          text: "لینک سایت مورد نظر را وارد نمایید",
          pattern: "",
          prefix: "URL",
          url: "qr.terminalads.com",
          img: "/media/socialIcon/40icon/location.svg",
          svg: "svgLocation",
        },
      ],
      instagram: [
        {
          label: "اینستاگرام",
          text: "نام کاربری خود را وارد نمایید",
          pattern: "https://instagram.com/",
          prefix: "@",
          url: "terminalads",
          img: "/media/socialIcon/40icon/instagram.svg",
          svg: "svgInstagram",
        },
      ],
      whatsapp: [
        {
          label: "واتساپ",
          text: "+989123456789",
          pattern: "wa.me/",
          prefix: "mdi-phone",
          url: "+982191017077",
          img: "/media/socialIcon/40icon/whatsapp.svg",
          svg: "svgWhatsapp",
        },
      ],
    };

    Bus.$on("socialMedias", (value) => {
      this.cardTexts.socialMedia = value;
    });
  },

  computed: {
    defaultProfileImage() {
      return (
        this.$coreApi3 + "/storage/s5wXoRhzyw9PkGXA8qnIL2yvA3TPiXhwsFrwjmeX.png"
      );
    },
    defaultWebsite() {
      return this.$coreqrApi || "https://qr.terminalads.com";
    },
    fullLink() {
      return this.createdDomain?.replace("/", "") + "/" + this.createdId;
    },
  },

  methods: {
    ...mapActions("local", [
      "updateQrInfo",
      "updateQridentifier",
      "updateQrDomain",
      "updateQrId",
    ]),
    markQr() {
      if (
        !this.dtUrl ||
        typeof this.$refs["address-field"].dtUrlRule(this.dtUrl) !== "boolean"
      ) {
        this.$toast.clear();
        this.$toast.error("آدرس وارد شده صحیح نمی‌باشد!");
        return;
      }

      this.loading = true;
      let obj = {
        type: "consultationQr",
        qrType: "dynamic",
        title: this.cardTexts.visitName,
        domain_id: this.domainId,
        data: JSON.stringify({
          theme: "",
          data: this.cardTexts,
        }),
        qr: JSON.stringify(this.qrDesign),
      };
      if (this.dtUrl && this.dtUrl.length > 0) {
        obj.identifier = this.dtUrl;
      }

      this.$api
        .post("/v1/testQr/store", obj)
        .then(({ data }) => {
          this.loading = false;
          this.createdDomain = this.$refs["address-field"].destItems.find(
            (item) => item.id === this.domainId,
          ).name;
          this.createdId = data.data.identifier;
          this.info = data.data;
          this.updateQrInfo(data.data);
          this.updateQridentifier(data.data.identifier);
          this.updateQrDomain(data.data.domain_id);
          this.updateQrId(data.data.id);
          // this.qrShow = ;
          this.$toast.success("کیوآر فرم درخواست شما با موفقیت ساخته شد");
          if (this.e6 === 1) {
            this.$nextTick(() => {
              setTimeout(() => {
                this.$refs.qrCanvas.appendCanvas(data.data.link);
              }, 500);
              setTimeout(() => {
                this.qrUpdate(false);
              }, 1000);
            });
          }
        })
        .catch((error) => {
          const response = error.response;
          if (response.status === 422)
            this.$modal.error("خطا", response.data.message);
          const errorMap = {
            "The آدرس کیوآر has already been taken.": "errors.qr_address_taken",
          };

          const translatedErrors = {};

          if (response?.data?.errors) {
            const backendErrors = response.data.errors;

            Object.entries(backendErrors).forEach(
              ([fieldKey, fieldMessages]) => {
                try {
                  translatedErrors[fieldKey] = fieldMessages.map((msg) => {
                    const key = errorMap[msg];
                    return key ? this.$t(key) : msg;
                  });

                  const msg = fieldMessages[0];
                  const key = errorMap[msg];
                  this.$toast.error(key ? this.$t(key) : msg, {
                    timeout: 3000,
                  });
                } catch (e) {
                  console.log("Error in mapping translation: ", e);
                }
              },
            );

            this.errors = translatedErrors;
          } else {
            this.$toast.error(this.$t("qr_creation_failed"));
          }

          let el = document.getElementById("qr-address");
          if (el) {
            el.scrollIntoView({ behavior: "smooth", block: "center" });
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
  qrUpdate(final = false) {
      if (final || !this.AutoSave) {
        this.loading = true;
      } else {
        this.isAutoSaving = true;
      }
      const data = new FormData();
      data.append("type", "consultationQr");
      data.append("image", this.qrSvgDataUrl);
      data.append("qrType", "dynamic");
      data.append("domain", this.createdDomain);
      data.append("identifier", this.createdId || "");
      data.append("qr_id", this.info.qrId);
      data.append("_method", "PUT");
      data.append("qr", JSON.stringify(this.qrDesign));
      data.append(
        "data",
        JSON.stringify({
          theme: this.theme,
          data: this.cardTexts,
        }),
      );

      this.$api
        .post("/v1/testQr/update", data)
        .then((res) => {
          if(final || !this.AutoSave)
              this.$toast.success("کیوآر فرم درخواست شما با موفقیت ویرایش شد");
          if (this.e6 > 1) {
            if(final)
            this.goto("qr/list");
          } else {
            this.e6 += 1;
          }
        })
        .catch((err) => {
          this.loading = false;
          this.isAutoSaving = false;
        })
        .finally(() => {
          this.loading = false;
          this.isAutoSaving = false;
        });
    },
  },
};
</script>

<style scoped>
.v-tab--active {
  background-color: var(--v-primary-base) !important;
  border-radius: 50px;
  color: white;
}
</style>
